module.exports = __webpack_public_path__ + "static/helpscout-e8536106294c6f6c82afb6df1f7d3b72.svg";